<template>
  <main role="main" class="col content-spacing">
    <loading-list v-if="viewData.loading"></loading-list>
    <b-container v-else>
      <b-row>
        <b-col>
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
          >
            <h1 class="h2">
              {{ viewData.id ? `Editar ${state.name}` : 'Novo Contrato' }}
            </h1>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-breadcrumb
            :items="[
              {
                text: 'Lista de Contratos',
                href: '#/contracts',
              },
              {
                text: 'Cadastro de Contratos',
                href: '#',
                active: true,
              },
            ]"
          ></b-breadcrumb>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-form>
              <error-container v-bind:errors="viewData.errors || []" />

              <b-form-group label="Nome">
                <b-form-input
                  v-model="state.name"
                  required
                  placeholder="Informe o nome do contrato"
                  :state="isOk('name')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('name')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Versão">
                <b-form-input
                  v-model="state.version"
                  required
                  placeholder="Informe a versão"
                  :state="isOk('version')"
                ></b-form-input>
                <b-form-invalid-feedback>{{}}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-3"
                label="Perfil"
                label-for="input-group-3"
              >
                <select v-model="state.profile" class="form-control">
                  <option disabled value>Selecione o perfil</option>
                  <option value="consumer">Consumidor</option>
                  <option value="trader">Comercializador</option>
                  <option value="partner">Parceiro</option>
                  <option value="investor">Investidor</option>
                </select>
                <div :class="{ 'is-invalid': !isOk('profile') }"></div>
                <b-form-invalid-feedback v-if="isOk('profile') === false">{{
                  getError('profile')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-7"
                label="Tipo"
                label-for="input-group-7"
              >
                <select v-model="state.contractType" class="form-control">
                  <option disabled value>Selecione o Tipo</option>
                  <option value="POLITICA_PRIVACIDADE"
                    >Politica de privacidade</option
                  >
                  <option value="TERMO_PLATAFORMA"
                    >Termos de Uso da Plataforma</option
                  >
                  <option value="TERMO_USO_CONSUMIDOR"
                    >Termos de Uso do Consumidor</option
                  >
                  <option value="TERMO_USO_TRADER"
                    >Termos de Uso do Comercializador</option
                  >
                  <option value="TERMO_USO_INVESTOR"
                    >Termos de Uso do Investidor</option
                  >
                  <option value="TERMO_USO_PARTNER"
                    >Termos de Uso do Parceiro</option
                  >
                  <option value="CONTRATO_MUTUO_INVESTOR"
                    >Contrato de Mútuo</option
                  >
                  <option value="CONDICOES_ESPECIFICAS_INVESTOR"
                    >Condições Específicas</option
                  >
                </select>

                <div :class="{ 'is-invalid': !isOk('contractType') }"></div>
                <b-form-invalid-feedback
                  v-if="isOk('contractType') === false"
                  >{{ getError('contractType') }}</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-group-2"
                label="Conteúdo"
                label-for="input-2"
              >
                <b-form-textarea
                  v-model="state.content"
                  placeholder="Informe o conteúdo"
                  rows="3"
                  max-rows="6"
                  :state="isOk('content')"
                ></b-form-textarea>
                <b-form-invalid-feedback>{{
                  getError('content')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-3"
                label="Status"
                label-for="input-group-3"
              >
                <select v-model="state.active" class="form-control">
                  <option disabled value>Selecione o status</option>
                  <option value="1">Ativo</option>
                  <option value="0">Inativo</option>
                </select>
                <div :class="{ 'is-invalid': !isOk('active') }"></div>
                <b-form-invalid-feedback v-if="isOk('active') === false">{{
                  getError('active')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <submit-button
                v-bind:action="() => save()"
                v-bind:label="'Salvar'"
              ></submit-button>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';

const API = new Api();

export default {
  name: 'contract-edit',
  data: function() {
    return {
      state: {
        name: '',
        version: '',
        content: '',
        active: 1,
        contractType: '',
        profile: '',
      },
      viewData: {
        id: 0,
        loading: false,
        errors: [],
      },
    };
  },
  computed: {},
  beforeMount: async function() {
    const _id = this.$route.params ? this.$route.params.id : 0;

    if (_id) {
      this.viewData.id = _id;

      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/contract/' + _id,
          method: 'get',
        });

        this.state = { ...result.model };
        this.viewData.loading = false;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    }
  },
  methods: {
    getError(property) {
      return helpers.getError(this.viewData.errors, property);
    },
    isOk(property) {
      let hasError = helpers.hasError(this.viewData.errors, property);
      if (hasError) {
        return false;
      }
    },
    updateUrl(url) {
      this.state.url = url;
    },
    setLoadingPhoto(loading) {
      this.viewData.loadingPhoto = loading;
    },
    async save() {
      try {
        const result = await API.post('/execute', {
          path: this.viewData.id
            ? `/contract/${this.viewData.id}`
            : '/contract/',
          method: this.viewData.id ? 'put' : 'post',
          data: this.state,
        });

        this.$toast.success('Contract incluída com sucesso');

        this.$router.push('/contracts');
      } catch (ex) {
        this.viewData.errors = helpers.getErrors(ex);
      }
    },
  },
  components: {
    'image-upload': require('../image-upload.vue').default,
  },
};
</script>
